// extracted by mini-css-extract-plugin
export default {"logo":"src-components-logo-styles-logo-XKCPA"};